<template>
  <div class="card card-custom" v-if="partner">
    <div class="card-body p-0">
      <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
        <div class="col-xl-12 col-xxl-12">
          <h2 class="text-center pb-10">Formulaire de modification d'un partenaire</h2>
          <FormPartner v-model="partner" @submit="submit"></FormPartner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FormPartner from "@/components/admin/partner/formPartner.vue";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "editPartner",
  components: {
    FormPartner,
  },
  data: () => ({
    partner: null,
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionPartenaires" },
      { title: "Gestion des partenaires", route: "gestionPartenaires" },
      { title: "Modifier un partenaire" },
    ]);

    var partnerId = this.$route.params.id;
    var partnerData = this.$route.params.partner;

    if (partnerData) {
      this.populatePartnerForm(partnerData);
    } else {
      Api.get(`/partners/${partnerId}`).then((partner) => {
        this.populatePartnerForm(partner.data);
      });
    }
  },
  methods: {
    submit: async function() { 
      let step = "Mise à jour des informations du partenaire";
      try {
        // Mise à jour des données
        await Api.patch('partners',this.partner.id, {
          name: this.partner.name,
          url: this.partner.url,
        });
        // Envoi du logo si partenaire crée et logo en argument
        if(this.partner && this.partner.id && this.partner.newLogo){
          step = "Mise à jour du logo du partenaire";
          const formLogoData = new FormData();
          formLogoData.append('logo', this.partner.newLogo);
          await Api.post(`partners/${this.partner.id}/media`, formLogoData);
        }
        Swal.fire({
          title: "",
          text: "Le partenaire a été modifié.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
        this.$router.push({ name: "gestionPartenaires"})
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "",
          text: `Une erreur est survenue lors de la modification du partenaire à l'étape : ${step}`,
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }
    },

    populatePartnerForm(partner) {
      this.partner = {
        //SPREAD OPERATOR (...)
        //Décomposition d'objets, permet de récupérer toutes les propriétés d'un objet d'un coup et de n'en surcharger
        //que certaines
        ...partner,
        newLogo : null,
      };
    },
  },
};
</script>
